import { gql } from '@apollo/client'

const ALL_PROGRAMS_EN = gql`
  query ProgramsQuery {
    programs_EN_LAS {
      _id
      data {
        id
        name
        securityKey
        description
        isActive
        address1
        areaRegionId
        latitude
        longitude
        agencyId
        shortDescription
        bedsAvailable
        ageTo
        ageFrom
        city
        hoursOfOperation
        operatingHours {
          isClosed
          open
          close
          dayOfWeekId
        }
      }
    }
  }
`

const ALL_PROGRAMS_ES = gql`
  query ProgramsQuery {
    programs_ES_LAS {
      _id
      data {
        id
        name
        securityKey
        description
        isActive
        address1
        latitude
        longitude
        areaRegionId
        agencyId
        shortDescription
        bedsAvailable
        ageTo
        ageFrom
        city
        hoursOfOperation
        operatingHours {
          isClosed
          open
          close
          dayOfWeekId
        }
      }
    }
  }
`

const ALL_PROGRAMS = {
  EN: ALL_PROGRAMS_EN,
  ES: ALL_PROGRAMS_ES,
}

export { ALL_PROGRAMS }
